'use strict';

var filters = angular.module('amexReconciliationApp');

filters.filter('transactionMerchantDisplayName',
  function selectMerchantName() {
    return function (transaction) {
      return (transaction.merchantName2 || transaction.merchantName);
    };
  });
filters.filter('transactionMerchant1DisplayName',
    function selectMerchantName() {
        return function (transaction) {
            return (transaction.merchantName);
        };
    });
filters.filter('transactionMerchant2DisplayName',
    function selectMerchantName() {
        return function (transaction) {
            return (transaction.merchantName2);
        };
    });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/filters/transactionMerchantDisplayName.js
// module id = 561
// module chunks = 0